/**
 * Button: the one component that sets the tone for every action on the site.
 *   variant="primary"    solid black pill
 *   variant="secondary"  outlined pill
 *   variant="text"       underlined text link with an arrow
 * The label rolls up on hover (a duplicate slides in from below) and the
 * arrow travels, so every button has the same small, physical motion.
 */
import { TLink } from "./TransitionProvider";

export default function Button({ variant = "primary", to, href, onClick, children, arrow = true, label, disabled, className = "", ...rest }) {
  const cls = `btn btn--${variant} ${className}`.trim();
  const inner = (
    <>
      <span className="btn-roll" aria-hidden={false}>
        <span className="btn-roll-a">{children}</span>
        <span className="btn-roll-b" aria-hidden="true">{children}</span>
      </span>
      {arrow && <span className="btn-arrow" aria-hidden="true">{href ? "↗" : "→"}</span>}
    </>
  );
  if (to) return <TLink to={to} label={label || (typeof children === "string" ? children : "")} className={cls} {...rest}>{inner}</TLink>;
  if (href) {
    const ext = /^https?:/.test(href);
    return <a href={href} className={cls} {...(ext ? { target: "_blank", rel: "noopener noreferrer" } : {})} {...rest}>{inner}</a>;
  }
  return <button type="button" className={cls} onClick={onClick} disabled={disabled} {...rest}>{inner}</button>;
}
